import { useState, useRef, useCallback } from 'react';

export function useToast() {
  const [toast, setToast] = useState(null);
  const timerRef = useRef(null);

  const notify = useCallback((type, msg) => {
    if (timerRef.current) clearTimeout(timerRef.current);
    setToast({ type, msg });
    timerRef.current = setTimeout(() => setToast(null), 4000);
  }, []);

  return { toast, notify };
}
